// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const machamp_gmax: PokeData = {
  "id": 10201,
  "name": "machamp-gmax",
  "height": 250,
  "weight": 10000,
  "base_experience": 227,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [],
  "moves": [
    "superpower",
    "meteor-assault",
    "jump-kick",
    "rolling-kick",
    "karate-chop",
    "double-kick",
    "coaching"
  ],
  "evolution_chain": {
    "id": 28,
    "item": null,
    "species": [
      {
        "name": "machop",
        "order": 72,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "machoke",
        "order": 73,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 66,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "machamp",
        "order": 74,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 67,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 127,
    "speed": 81,
    "ability_power": 192
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": true,
  "regional_variant": null
} as const;
